import { AdConfig, IAdDefinitionProps } from "redux-state/advertisement/types";
import { AdvertComponent } from "./advert-component";
import { AdvertErrorBoundary } from "./advert-error-boundary";
import { useCallback, useContext, useState } from "react";
import { ScreenSizeContext } from "page-context/column-layout/column-layout-context";
import { useSelector } from "react-redux";
import { IRepoState } from "redux-state/rootReducer";
import { getMergedAdData } from "./utils/ad-targeting-merge";
import { isDevEnv } from "utilities/consts/webpack-consts";
import { messageLog } from "utilities/helpers/logger/message-logger";
import classNames from "classnames";

export type AdvertEmbeddedComponentProps = IAdDefinitionProps & AdConfig;

export const AdvertEmbeddedComponent = (props: AdvertEmbeddedComponentProps) => {
    const adSize = useContext(ScreenSizeContext);
    const { adDefinitions, targeting, account: ac } = useSelector((state: IRepoState) => state.ADVERTISEMENT);
    const [adPopulated, setAdPopulated] = useState(false);
    const adDisplayTrueCB = useCallback(() => {
        setAdPopulated(true);
    }, []);

    const adData = getMergedAdData({
        ad: props,
        defs: adDefinitions,
        adSize,
    });

    if (!adData) {
        if (isDevEnv(false)) {
            messageLog.info(`Module ad config is incorrect: ${props.id}`);
        }
        return null;
    }

    if (ac) {
        return (
            <div className={classNames('u-textCenter', adPopulated ? '' : 'Tile--hide-empty')}>
                <AdvertErrorBoundary>
                    <AdvertComponent
                        {...adData}
                        targeting={targeting}
                        ac={ac}
                        origin={`YouTubePlayer ${props.id}`}
                        adDisplayTrueCB={adDisplayTrueCB}
                    />
                </AdvertErrorBoundary>
            </div>
        );
    } else {
        return null;
    }
};
